export type RoadmapStatus = "done" | "in-progress" | "planned";

export const STATUS_CONFIG: Record<RoadmapStatus, { label: string; color: string; dot: string }> = {
  done: { label: "Disponible", color: "text-emerald-400", dot: "bg-emerald-400" },
  "in-progress": { label: "En cours", color: "text-amber-400", dot: "bg-amber-400" },
  planned: { label: "Prévu", color: "text-ink-faint", dot: "bg-ink-faint/40" },
};
